
import { timeRangeOptions } from "@/utils/options";

const reasonOptions = [
    {id: 'DAMAGED', text: '已残损'},
    {id: 'DISCARD_INVENTORY', text: '弃置库存'},
    {id: 'FOUND', text: '已找到'},
    {id: 'LOST', text: '丢失'},
    {id: 'OTHER', text: '其它'}
]

const dispositionOptions = [
    {id: 'SELLABLE', text: '可售'},
    {id: 'DEFECTIVE', text: '存在瑕疵'},
    {id: 'CUSTOMER_DAMAGED', text: '因买家导致的残损'},
    {id: 'DISTRIBUTOR_DAMAGED', text: '因分销商导致的残损'},
    {id: 'WAREHOUSE_DAMAGED', text: '在库房出现残损'},
    {id: 'CARRIER_DAMAGED', text: '因承运人导致的残损'},
    {id: 'EXPIRED', text: '已过期'}
]

const dateTypeOptions = [
    {id: 'marketTime', text: '盘点时间(站点时区)'},
    {id: 'zeroZoneTime', text: '盘点时间(零时区)'},
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '仓库',
    prop: 'warehouseIds',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseIds',
        propsData: {
            multiple: true,
            placeholder: '仓库'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '原因',
    prop: 'reasonType',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'reasonType',
        propsData: {
            options: reasonOptions,
            placeholder: '原因'
        }
    }],
    defaultValue: ''
},  {
    label: '描述',
    prop: 'disposition',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'disposition',
        propsData: {
            options: dispositionOptions,
            placeholder: '描述'
        }
    }],
    defaultValue: ''
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: dateTypeOptions
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'marketTime'
}]
